import styled from "styled-components"

const TextArea = styled.textarea`
  border-radius: ${({ theme }) => theme.borders.softRadius};
  background-color: ${({ theme }) => theme.colors.greyLighter};
  box-shadow: 0 0 4px 0 rgba(119, 119, 119, 0.25) inset;
  border-width: 2px;
  border-color: ${({ theme }) => theme.colors.greyDisabled};
  width: 100%;
  padding: 1rem;

  ::placeholder {
    color: ${({ theme }) => theme.colors.greyDisabled};
    font-family: Karla;
    font-size: 16px;
    font-style: italic;
    font-weight: 500;
    line-height: normal;
  }
`

export default TextArea
